import { createContext } from 'utils/react-helpers';

const [ShippingCompanyProvider, useShippingCompany] = createContext({
  name: 'ShippingCompanyContext',
});

export { ShippingCompanyProvider, useShippingCompany };
